import React from "react";
import { Gift } from "lucide-react";
import {
  computePeriodScore,
  formatCompactNumber,
  leaderDisplayName,
  MIN_REWARD_WEEKLY_SCORE,
  WEEKLY_REWARDS,
} from "./leaderboardHelpers";

function RewardRow({ rank, reward, active, live }) {
  const liveName = live ? leaderDisplayName(live) : null;

  return (
    <div className={`alb-reward-row${active ? " alb-reward-row-live" : ""}`}>
      <span className={`alb-reward-rank alb-reward-rank-${rank <= 3 ? rank : "rest"}`}>
        #{rank}
      </span>
      {liveName ? (
        <span className="alb-reward-live" title={liveName}>
          {liveName}
        </span>
      ) : (
        <span className="alb-reward-live alb-reward-live-empty">— open</span>
      )}
      <span className="alb-reward-prizes">
        <em className="alb-reward-cash">{formatCompactNumber(reward.CASH)} CASH</em>
        <em className="alb-reward-coin">{formatCompactNumber(reward.COIN)} COIN</em>
      </span>
    </div>
  );
}

export default function LeaderboardRewardLadder({ topTen = [] }) {
  return (
    <section className="alb-rewards" aria-label="Weekly prize ladder">
      <header className="alb-rewards-head">
        <Gift size={14} aria-hidden />
        <div>
          <strong>Prize ladder</strong>
          <span>Top 10 at reset · {MIN_REWARD_WEEKLY_SCORE}+ weekly pts · ties pool those ranks</span>
        </div>
      </header>

      <div className="alb-rewards-list">
        {Array.from({ length: 10 }, (_, i) => {
          const rank = i + 1;
          const candidate = topTen[rank - 1];
          const live =
            candidate && computePeriodScore(candidate) >= MIN_REWARD_WEEKLY_SCORE
              ? candidate
              : null;
          return (
            <RewardRow
              key={rank}
              rank={rank}
              reward={WEEKLY_REWARDS[rank]}
              active={Boolean(live)}
              live={live}
            />
          );
        })}
      </div>
    </section>
  );
}
